import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
    // your Firebase credentials go here
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    apiKey: "AIzaSyDL_2SPVuK-xhJz04IGzu-PB1hiK9OT-Jc",
    authDomain: "ravimessenge.firebaseapp.com",
    databaseURL: "https://ravimessenge.firebaseio.com",
    projectId: "ravimessenge",
    storageBucket: "ravimessenge.appspot.com",
    messagingSenderId: "507440226788",
    appId: "1:507440226788:web:a315cc67145fa3536267f1",
    measurementId: "G-CNXDV4CTL9"
  
});

const db = firebaseApp.firestore()

export default db